import React from 'react';
import { Option } from '@monorepo/ui-kit';
import { useI18n } from '@monorepo/i18n';
import { FILTER_PARAMS, formatDateRange } from '@monorepo/helpers';
import Filter from '../Filter';

type TProps = {
  options: Option[];
  filterKey: string;
  className?: string;
};

const DateRangeFilter = ({ options, filterKey, className = '' }: TProps) => {
  const { t } = useI18n();
  const preparedItems = (): Option[] =>
    options.map((option) => {
      const { label, value } = option;
      const date =
        value !== FILTER_PARAMS.all ? formatDateRange(Number(value)) : value;
      return {
        label: t(label),
        value: date
      };
    });

  return (
    <Filter
      className={className}
      valueKey={filterKey}
      options={preparedItems()}
      key="dateRangeFilter"
    />
  );
};

export default DateRangeFilter;
